import React, { useState } from 'react';

import { Box, Button, H3, Link, Text } from '@betterment/samba-react';
import { Flex } from '@betterment/style-closet-react';

import { GraphQLProvider } from '../../../../providers/GraphQLProvider';
import { IdempotencyProviderWithFeatureRegistry } from '../../../../providers/IdempotencyProviderWithFeatureRegistry';
import brochureUrl from '../../../../utils/brochureUrl';
import { DismissableCard } from '../../../DismissableCard';
import { ApplyCashFirstBillingModal } from '../apply-cash-first-billing-modal/ApplyCashFirstBillingModal';
import { CashFirstBillingPromptCardProps } from '../data';

export const cardName = 'cash_billing_prompt';

export const CashFirstBillingPromptCard: React.FC<CashFirstBillingPromptCardProps> = ({ billingPlans }) => {
  const [isApplyCashFirstBillingModalOpen, setIsApplyCashFirstBillingModalOpen] = useState(false);

  return (
    <DismissableCard role="article" aria-label="cashFirstBillingPrompt" cardName={cardName}>
      <Box>
        <H3 variant="title200" css={{ pb: 'space.100' }}>
          New: Bill from Cash Reserve first
        </H3>
        <Flex marginBottom="1.6rem" maxWidth="920px">
          <Text css={{ color: 'text' }}>
            <Text as="span" css={{ color: 'text' }}>
              You can now bill advisory fees from eligible accounts in this order: <b>Cash Reserve first</b>, then{' '}
              <b>taxable</b>, then <b>tax-advantaged</b>. Apply this setting to all existing plans at once, or customize
              it for individual plans anytime.
            </Text>{' '}
            <Link href={brochureUrl('/advisors/resources/billing-plans')} target="_blank" rel="noopener noreferrer">
              Learn More
            </Link>
            .
          </Text>
        </Flex>
        <Button
          data-testid="applyCashFirstBillingButton"
          onClick={() => {
            setIsApplyCashFirstBillingModalOpen(true);
          }}
          variant="solidPrimary"
        >
          Apply Cash Reserve first
        </Button>
      </Box>
      <GraphQLProvider>
        <IdempotencyProviderWithFeatureRegistry featureName="billingPlans">
          <ApplyCashFirstBillingModal
            billingPlans={billingPlans}
            closeHandler={() => setIsApplyCashFirstBillingModalOpen(false)}
            isOpen={isApplyCashFirstBillingModalOpen}
            cardName={cardName}
          />
        </IdempotencyProviderWithFeatureRegistry>
      </GraphQLProvider>
    </DismissableCard>
  );
};
